import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchBarServiceService {
  
  
  
  constructor() { }
  
  display = false;
  // A listener that returns an Observable gets switchMapped, so a new query aborts the old request.
  searchButtonListener: ((text: string) => Observable<unknown> | void) | null;
  lastUpdate: Date;
  refreshListener;
  
  reset() {
    this.display = false;
    this.searchButtonListener = null;
    this.lastUpdate = null;
    this.refreshListener = null;
  }
  
  initListener(display, searchButtonListener, lastUpdate, refreshListener) {
    this.display = display;
    this.searchButtonListener = searchButtonListener;
    this.lastUpdate = lastUpdate;
    this.refreshListener = refreshListener;
  }
}

